import {
  Group,
  Paper,
  Text,
  UnstyledButton,
  Tooltip,
} from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";

const CardStat = ({
  stat,
  txtWeight = 700,
  txtSize = "xl",
  labelSize = "xs",
  iconSize = 30,
  ...props
}) => {
  const { t } = useTranslation();

  const card = (
    <UnstyledButton sx={{ display: "block", width: "100%" }}>
      <Paper radius="md" p="md" key={stat.label} {...props} shadow="md" sx={{ width: "100%" }}>
        <Group position="apart" noWrap>
          <stat.icon size={iconSize} stroke={1} color={stat.color} />
          <div style={{ textAlign: "right" }}>
            <Text
              color="dimmed"
              size={labelSize}
              transform="uppercase"
              weight={700}
            >
              {t(stat.label)}
            </Text>
            <Text weight={txtWeight} size={txtSize}>
              {stat.msg}
            </Text>
          </div>
        </Group>
      </Paper>
    </UnstyledButton>
  );

  if (!stat.tooltipLines?.length) return card;

  return (
    <Tooltip
      label={
        <>
          {stat.tooltipLines.map((line) => (
            <div key={line.label}>
              {t(line.label)}: {line.value}
            </div>
          ))}
        </>
      }
      withArrow
      multiline
      width={220}
    >
      <div style={{ width: "100%" }}>{card}</div>
    </Tooltip>
  );
};

export default CardStat;
